import React, { Component } from 'react';
import parse from 'html-react-parser';
import { Container, Carousel, Tabs, Tab } from 'react-bootstrap';
import { FaArrowRight, FaArrowDown, FaQuestion, FaBookmark, FaBook, FaAsterisk, FaRegCalendarDays, FaRegClock } from 'react-icons/fa6';
import { GetText, ReplaceText, ReplacePrefixUrl, ReplaceOutputTextHTML } from '../config/helper';
import NumberFormats from '../config/number-format';
import DateTimeFormats from '../config/date-time-format';
import CourseBlock from '../inc/course/Block';
import LibraryBlock from '../inc/library/Block';
import Loading from '../inc/Loading';
import TagHeaders from '../inc/Headers';
import ImgLogoLogitech from '../img/logo/logitech.png';
import ImgLogoGoogleCloud from '../img/logo/google-cloud.png';
import ImgLogoCiscoMeraki from '../img/logo/cisco-meraki.png';
import ImgLogoMicrosoft from '../img/logo/microsoft.png';
import ImgLogoOracleNetsuite from '../img/logo/oracle-netsuite.png';
import '../config/global';
import '../css/jumbotron.css';
import '../css/carousel.css';

const authKey = global.config.kindcode.training[1]+global.config.authBearerKey;
const authKey2 = global.config.kindcode.training[2]+global.config.authBearerKey;
const authKey3 = global.config.kindcode.training[21]+global.config.authBearerKey;

function getBannerData() {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly","category":"'+global.config.bannerType[1].value+'"}';
    var dataSend = JSON.parse(dataText);
    fetch(global.config.urlLink+"/bannerlist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey3
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      if(resultJson.status === "200") {
        resolve(resultJson.values);
      } else {
        resolve([])
      }
    });
  });
}

function getLibraryData() {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly"}';
    var dataSend = JSON.parse(dataText);
    
    fetch(global.config.urlLink+"/librarylist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey
      }, 
      body : JSON.stringify(dataSend)
    }).then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    }).then(resultJson => {
      var librarySend = {};
      var resultData = [];
      var resultDataCategory = [];
      var inum=0;
      if(resultJson.values.length > 0) {
        var libraryDataList = resultJson.values;
        if(global.config.specialCategory !== undefined && global.config.specialCategory.length > 0) {
          libraryDataList = resultJson.values.filter(libdata => {
            // Return true to keep the item, so we check if 'some' in excludeObjects is FALSE
            return !global.config.specialCategory.some(excludeItem => 
                excludeItem.value === libdata.content.categoryName 
            );
          });  
        } 
        for (var i in libraryDataList) {
          var content = libraryDataList[i].content;
          content.id = libraryDataList[i].docid;
          resultData.push(content);
          if (resultDataCategory.indexOf(content.categoryName) < 0) {
            resultDataCategory.push(content.categoryName);
          }
          inum++;
          if(inum === libraryDataList.length) {
            librarySend.librarydata = resultData;
            librarySend.librarycategory = resultDataCategory;
            resolve(librarySend);
          }
        }
      } else {
        librarySend.librarydata = resultData;
        librarySend.librarycategory = resultDataCategory;
        resolve(librarySend);
      }
    });
  });
}

function getCourseData() {
  return new Promise((resolve) => {
    var dataText ='{"keyword":"","pageShow":"10","lang":"'+localStorage.getItem('language')+'","form_id":"pubonly"}';
    var dataSend = JSON.parse(dataText);
    
    fetch(global.config.urlLink+"/courselist", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': authKey2
      }, 
      body : JSON.stringify(dataSend)
    })
    .then(response => {
      if(response.status === 200) {
        return response.json();
      } else {
        console.log('Something happened wrong');
      }
    })
    .then(resultJson2 => {
      var courseSend = {};
      var resultDataCourse = [];
      var resultDataCourseFeatured = [];
     
      if(resultJson2.values.length > 0) {
        var courseListFeatured = resultJson2.values.filter((list1) =>  {
          return (list1.content.isFeatured === '1');
        });

        var courseListNoFeatured = resultJson2.values.filter((list2) =>  {
          return (list2.content.isFeatured === undefined || list2.content.isFeatured === '0' || list2.content.isFeatured === '');
        });
        courseSend.coursedata = courseListNoFeatured;
        courseSend.coursefeature = courseListFeatured;
        resolve(courseSend);
      } else {
        courseSend.coursedata = resultDataCourse;
        courseSend.coursefeature = resultDataCourseFeatured;
        resolve(courseSend);
      }
    });
  });
}
async function getAllDatas() {
    const libraryresult = getLibraryData();
    const courseresult = getCourseData();
    const bannerresult = getBannerData();
    
    const [thing1, thing2, thing3] = await Promise.all([libraryresult, courseresult, bannerresult]);
    var arrReturnValue = {};
    arrReturnValue.librarydata = thing1.librarydata;
    arrReturnValue.librarycategory = thing1.librarycategory;

    arrReturnValue.coursedata = thing2.coursedata;
    arrReturnValue.coursefeatures = thing2.coursefeature;
    
    arrReturnValue.bannerdata = thing3;
    return arrReturnValue;
}
export default class HomeGuest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courseList: [],
      courseFeatured: [],
      libraryList: [],
      libraryCategories: [],
      bannerList: [],
      bannerBenefitList: [],
      isLoad: false
    }
  }

  componentDidMount() {
    const benefitdata = {
      "ENG": [
          {"picture":"/img/illustration-1c.jpg", "title": "Flexible Learning","content": "Novaio Academy Library allows users to access various learning modules and videos anytime and anywhere. Learn without limitations according to your desired time; just choose the topic that is relevant to your needs."},
          {"picture":"/img/illustration-2c.jpg", "title": "Interactive Live Learning","content":"Novaio Academy Workshop allows users to take part in interactive training in real-time. Both online and onsite, these sessions provide an opportunity to ask questions directly to the presenters, discuss with other participants, and gain hands-on experience in the field."},
          {"picture":"/img/illustration-3c.jpg", "title": "Quality Material from Experts","content":"Compiled by experts in their fields, the materials in Novaio Academy Library and Workshop provide in-depth and applicable learning. The quality of the materials is guaranteed for each learning method."},
          {"picture":"/img/illustration-4c.jpg", "title": "Focus on Relevant Skill Development","content":"We understand the importance of skills that are in line with the needs of today's workforce, so the materials in Novaio Academy are always updated. This helps users improve their digital skills and professionalism that are ready to be applied in their work."},
      ],
      "IDN": [
        {"picture":"/img/illustration-1c.jpg", "title": "Fleksibel","content":"Nikmati kebebasan belajar kapan pun dan di mana pun melalui Library Novaio Academy yang komprehensif, memungkinkan Anda fokus pada topik yang paling relevan."},
        {"picture":"/img/illustration-2c.jpg", "title": "Pembelajaran Live yang Interaktif","content":"Partisipasi dalam workshop kami memberikan kesempatan untuk berinteraksi langsung dengan para pemateri dan memperoleh pengalaman langsung di lapangan."},
        {"picture":"/img/illustration-3c.jpg", "title": "Materi Berkualitas dari Para Ahli","content":"Disusun oleh para ahli di bidangnya, materi di Library dan Workshop Novaio Academy memberikan pembelajaran yang mendalam dan dapat langsung diterapkan. Kualitas materi terjamin untuk setiap metode pembelajaran."},
        {"picture":"/img/illustration-4c.jpg", "title": "Fokus pada Pengembangan Skill yang Relevan","content":"Tingkatkan skill digital dan profesional Anda melalui materi yang selalu diperbarui, dirancang untuk memenuhi tuntutan pasar kerja saat ini."},
      ],
    }
    getAllDatas().then((response) => {
      this.setState({
        courseList: response.coursedata,
        courseFeatured: response.coursefeatures,
        libraryList: response.librarydata,
        libraryCategories: response.librarycategory,
        bannerList: response.bannerdata,
        bannerBenefitList : GetText() ? benefitdata.IDN : benefitdata.ENG,
        isLoad: true
      }) 
    });
  }
  
  render() {
    return (
      <div className="home">
          <TagHeaders value={
                        {	
                          docid: '', 
                          title: '', 
                          description: '',
                          links: global.config.urlHost+'/'
                        }
                      }/>
        {
          this.state.isLoad === true ? 
            this.state.bannerList.length > 0 ? (
              <section>
                <Container>
                  <Carousel id="banner-homepage" slide={true} fade={true} indicators={false}>
                    {
                      this.state.bannerList
                      .sort((a,b) => b.content.bannerNumber - a.content.bannerNumber)
                      .map((bannerItem, a) => {
                        var bannerListData = bannerItem.content;
                        return (
                          <Carousel.Item >
                          <div lassName="align-items-center mx-0 w-full">
                            {(bannerListData.bannerLinkurl !== "" && bannerListData.bannerLinkurl !== undefined && bannerListData.bannerLinkurl !== ".")? 
                              <a href={bannerListData.bannerLinkurl} target={bannerListData.bannerTargeturl} noreferrer><img src={bannerListData.bannerFileurl} className="img-fluid w-100 rounded"  /></a>
                            : <img src={bannerListData.bannerFileurl} className="img-fluid w-100 rounded" alt="" border="0" />
                            }
                          </div>
                          </Carousel.Item>
                        )
                      })
                    } 
                    </Carousel>
                </Container>
                <div className="separator"><div className="icon"><FaArrowDown className='bg2-secondary'/></div></div>
              </section>
            ) : (
              <section>
                <Container>
                  <div className="banner-home text-start text-white bg-secondary jumbotron">
                    <div className="row">
                      <div className="col-md-8">
                        {
                          GetText() ? (
                            <div className="mt-5 mb-5">
                              <h1>Daftar dan dapatkan kelas workshop baru setiap bulannya</h1>
                              <p>Ekosistem Cloud selalu berubah, perbarui pengetahuan teknologi informasi dan digitalmu hanya di NOVAIO ACADEMY</p>
                              <a href="/login" className="btn btn-lg btn-primary mt-3">Daftar Sekarang!</a>
                            </div>
                          ) : (
                            <div className="mt-5 mb-5">
                              <h1>Join our new online workshops every month</h1>
                              <p>The cloud ecosystem is constantly changing, keep up with the latest developments in technology and information only at NOVAIO ACADEMY</p>
                              <a href="/login" className="btn btn-lg btn-primary mt-3">Join Now!</a>
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                </Container>
                <div className="separator"><div className="icon"><FaArrowDown className='bg2-secondary'/></div></div>
              </section>
            )
          : <section><Container><div style={{height:"380px"}}></div></Container></section>
        }
        
        {
          this.state.courseList.length > 0 ? (
            <section>
              <Container>
                <div className="bg-light p-5 br-8">
                  {
                    GetText() ? (
                      <>
                      <div>
                        <h4 className="text-start mb-1">Workshop Terbaru</h4>
                        <p className="text-start mb-4">Temukan berbagai sesi pelatihan terbaru yang berlangsung secara live, baik online maupun offline. Pelajari langsung dari para ahli dan dapatkan pengalaman belajar yang lebih interaktif dan aplikatif.</p>
                      </div>
                      </>
                    ) : (
                      <>
                      <div>
                        <h4 className="text-start mb-1">Latest Workshop</h4>
                        <p className="text-start mb-4">Find the latest training sessions taking place live, both online and offline. Learn directly from experts and get a more interactive and applicable learning experience.</p>
                      </div>
                      </>                      
                    )
                  }
                  <div className="row">
                    {
                      this.state.courseList
                      .sort((a,b) => b.content.courseDate._seconds - a.content.courseDate._seconds)
                      .slice(0,4)
                      .map((courseItem, i) => {
                        return (
                          <div className="col-md-3" key={i} >
                            <CourseBlock value={courseItem}/>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
                <div className="mt-4 text-end">
                  <a href="/courses" className="link-more">{GetText() ? "Workshop Lainnya" : "Browse Workshops"} <FaArrowRight/></a>
                </div>
              </Container>
              <div className="separator"><div className="icon"><FaQuestion className='bg2-secondary'/></div></div>
            </section>
          ) : ''
        }
        <section className="slider">
          <Container>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <h4 className="text-center">
                  <span className="label-rounded bg2-secondary">{GetText() ? "Kenapa Harus Belajar di Novaio Academy?" : "Why Choose Novaio Academy?"}</span>
                </h4>
                <Carousel id="benefit-banner" slide={false} fade={true}>
                  {
                    this.state.bannerBenefitList
                    .map((bannerBenefitItem) => {
                      return (
                        <Carousel.Item>
                          <div className="align-items-center mx-0 w-full mt-3" style={{height:"550px"}}>
                              <Carousel.Caption>
                              <div className="p-0" style={{height: "350px"}}><img src={process.env.PUBLIC_URL + bannerBenefitItem.picture} alt={bannerBenefitItem.title} /></div>
                              <div style={{height: "140px"}}>
                                <h3 className="text-dark">{bannerBenefitItem.title}</h3>
                                <p className="text-dark">{bannerBenefitItem.content}</p>
                                </div>
                              </Carousel.Caption>
                            </div>
                          </Carousel.Item>
                      )
                    })
                  }
                </Carousel>
              </div>
            </div>
          </Container>
          <div className="separator"><div className="icon"><FaBookmark className="bg2-secondary"/></div></div>
        </section>
        {
          this.state.courseFeatured.length > 0 ? (
            <section className="featured-home">
              <Container>

                <Carousel id="course-featured" slide={true} fade={true} indicators={false}>
                  {
                    this.state.courseFeatured
                    .sort((a,b) => b.content.courseDate._seconds - a.content.courseDate._seconds)
                    .slice(0,4)
                    .map((courseItemFeatured, i) => {
                      var courseListFeatured = courseItemFeatured.content;
                      return (
                        <Carousel.Item >
                          <div className="row align-items-stretch mx-0">
                            <div className="col-md-5 bg-light p-5 br-8">
                              <div className="row">
                                <div className="col">
                                  <h4>{GetText() ? "Workshop Unggulan" : "Featured Workshop"}</h4>              
                                </div>
                                <div className="col-auto text-end">
                                  <p className="text-primary mt-1"><strong>{courseListFeatured.categoryName}</strong></p>
                                </div>
                              </div>
                              <div className="text-center">
                                <img className="mxw h-300 br-8 mt-2" style={{maxWidth:"360px", maxHeight:"400px"}} src={courseListFeatured.coursePicture} alt={ReplaceText(courseListFeatured.courseTitle)}/>
                                <h5 className="my-4" style={{height:"50px"}}>{parse(ReplaceOutputTextHTML(courseListFeatured.courseTitle))}</h5>
                                <p>
                                  <FaRegCalendarDays className="me-1"/>
                                  {courseListFeatured.courseDate ? DateTimeFormats(courseListFeatured.courseDate._seconds,"date-long") : ''}
                                  <FaRegClock className="ms-3 me-1"/>
                                  {courseListFeatured.courseDate ? DateTimeFormats(courseListFeatured.courseStartTime._seconds,"time-24") : ''}
                                </p>
                                {/* <p>{ReplaceText(courseListFeatured.courseShortDesc)}</p> */}
                                <p><strong>{courseListFeatured.courseCurrency === global.config.currency.name[0] ? global.config.currency.symbol[0] : global.config.currency.symbol[1]} {NumberFormats(courseListFeatured.coursePrice)}</strong></p>
                                <p><a href={"/login/?redirect=checkout/" + courseItemFeatured.docid} className="btn btn-lg btn-outline-primary">{GetText() ? "Pesan Tiket" : "Book Ticket"}</a></p>
                                <p><a href={"/course/" + ReplacePrefixUrl(courseListFeatured.courseTitle) + "/" + courseItemFeatured.docid} className="link-more">{GetText() ? "Selengkapnya" : "View Detail"} <FaArrowRight/></a></p>
                              </div>
                            </div>
                            <div className="col-md-1"></div>
                            <div className="col-md-6 agenda p-5 br-8" style={{height:"700px"}}>
                              <h4 className="text-start mb-4">{GetText() ? "Pengantar" : "Introduction"}</h4>
                              <p className="text-start mb-5">{parse(ReplaceOutputTextHTML(courseListFeatured.courseShortDesc))}</p>
                              {
                                (courseItemFeatured.subcontentlist.length > 0) ? (
                                  <div className="agenda-list">
                                    <h4 className="text-start mb-4">Agenda</h4>
                                    {
                                      courseItemFeatured.subcontentlist
                                        .sort((a, b) => a.subcontent.agendaTime._seconds - b.subcontent.agendaTime._seconds)
                                        .map((agenda, i) => {
                                        return (
                                          <div className="row agenda-item" key={i}>
                                            <div className="col-md-3">
                                              <label className="label-rounded-2 bg2-secondary">{DateTimeFormats(agenda.subcontent.agendaTime._seconds,"time-24")}</label>
                                            </div>
                                            <div className="col-md-9 text-start">
                                              <h5>{parse(ReplaceOutputTextHTML(agenda.subcontent.agendaTitle))}</h5>
                                              <p className="clamp-3">{parse(ReplaceOutputTextHTML(agenda.subcontent.agendaDesc))}</p>
                                            </div>
                                          </div>
                                        )
                                      })
                                    }
                                  </div>  
                                ) : ''
                              }
                              <div className="agenda-more"></div>
                            </div>
                          </div>
                        </Carousel.Item>
                      )
                    })
                  }
                    
                  </Carousel>
                
              </Container>
              <div className="separator"><div className="icon"><FaBook className="bg2-secondary" /></div></div>
            </section>
          ) : ''
        }
        {
          this.state.libraryList.length > 0 ? (
            <section>
              <Container>
                <div className="bg-light p-5 br-8">
                  {
                    GetText() ? (
                      <>
                        <h4 className="text-start mb-1">Library</h4>
                        <p className="text-start mb-4">Tingkatkan keterampilan digital Anda dengan beragam materi yang dapat dipelajari sesuai paket langganan. Belajar fleksibel, kapan saja dan di mana saja!</p>
                      </>
                    ) : (
                      <>
                        <h4 className="text-start mb-1">Library</h4>
                        <p className="text-start mb-4">Improve your digital skills with a variety of materials that can be studied according to the subscription package. Learn anytime, anywhere!</p>
                      </>                      
                    )
                  }
                  <Tabs className="nav-scroll" defaultActiveKey="0" variant="pills" id="tab">
                    {
                      this.state.libraryCategories
                      .sort((a, b) => { return (a < b) ? -1 : ((a > b) ? 1 : 0) })
                      .map((libraryCategory, i) => {
                        return (
                          <Tab className="pt-4" eventKey={i} title={libraryCategory} key={i}>
                            <div className="row">
                              {
                                this.state.libraryList
                                .sort((a, b) => b.createDate._seconds - a.createDate._seconds)
                                .filter(libraryItem => libraryItem.categoryName === libraryCategory)
                                .slice(0, 4)
                                .map((libraryItem, j) => {
                                  return (
                                    <div className="col-md-3" key={j}>
                                      <LibraryBlock value={libraryItem} key={"library" + j}/>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </Tab>
                        )
                      })
                    }
                  </Tabs>
                </div>
                <div className="mt-4 text-end">
                  <a href="/libraries" className="link-more">{GetText() ? "Library Lainnya" : "Browse Libraries"} <FaArrowRight/></a>
                </div>
              </Container>
              <div className="separator"><div className="icon"><FaArrowDown className='bg2-secondary'/></div></div>
            </section>
          ) : <Loading value={{id:'library-area', divstyle:{}, componentstyle: {}}}/>
        }
        <section>
          <Container>
            <div className="text-center text-white bg-secondary banner-second jumbotron">
              {
                GetText() ? (
                  <>
                    <h2>Dapatkan tiket workshop pertamamu hari ini!</h2>
                    <p>Setiap kelas termasuk 1 sertifikat, 100 peserta, 5 sesi, dan lebih dari 1 pembicara.</p>
                    <a href="/login" className="btn btn-lg btn-primary mt-3">Daftar Sekarang!</a>
                  </>
                ) : (
                  <>
                    <h2>Get your first workshop ticket today!</h2>
                    <p>Each class consists of 1 certificate, 100 class participants, 5 sessions, and more than 1 keynote.</p>
                    <a href="/login" className="btn btn-lg btn-primary mt-3">Register Now!</a>
                  </>
                )
              }
            </div>
          </Container>
          <div className="separator"><div className="icon"><FaAsterisk className="bg2-secondary" /></div></div>
        </section>
        <section>
          <Container>
            <div className="p-4 text-center">
            {
                GetText() ? (
                  <>
                    <h4 className="text-center"><span className="label-rounded bg2-secondary">Disponsori oleh</span></h4>
                    <p className="p-4">Kami mendapat dukungan dari banyak sponsor yang berpartisipasi dalam menyelenggarakan acara ini</p>
                  </>
                ) : (
                  <>
                    <h4 className="text-center"><span className="label-rounded bg2-secondary">Sponsored by</span></h4>
                    <p className="p-4">We have the support of many sponsors who participated in organizing this event</p>
                  </>
                )
              }
              <div className="row justify-content-center p-4">
                <div className="col-6 col-md-2 mb-sm-4 mb-4">
                  <img className="w-100" src={ImgLogoLogitech} alt="Logitech"/>
                </div>
                <div className="col-6 col-md-2 mb-sm-4 mb-4">
                  <img className="w-100" src={ImgLogoGoogleCloud} alt="Google Cloud"/>
                </div>
                <div className="col-6 col-md-2 mb-sm-4 mb-4">
                  <img className="w-100" src={ImgLogoCiscoMeraki} alt="Cisco Meraki"/>
                </div>
                <div className="col-6 col-md-2 mb-sm-4 mb-4">
                  <img className="w-100" src={ImgLogoMicrosoft} alt="Microsoft"/>
                </div>
                <div className="col-6 col-md-2 mb-sm-4 mb-4">
                  <img className="w-100" src={ImgLogoOracleNetsuite} alt="Oracle NetSuite"/>
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    );
  }
}